<!-- eslint-disable max-len -->
<template>
  <div class="studio-page-wrapper">
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">ADMINISTRATOR</div>
      <div class="d-flex m__t--45">
        <template v-for="(tab, index) in tabMenu">
          <div
            v-if="tab.show"
            :key="tab.label"
            :class="[
              { 'm__r--35': index < tabMenu.length - 1 },
              tab.active ? 'tab-experience-manager-active' : 'tab-experience-manager'
            ]"
            @click="$router.replace(tab.url)"
          >
            {{ tab.label }}
          </div>
        </template>
      </div>
    </div>

    <div class="studio-page-administrator-content">
      <div class="wrap-company-setting">
        <!-- Side Menu -->
        <div class="side-menu">
          <div
            v-for="menu in sideMenu"
            :key="menu.id"
            :class="{ 'active': sideMenuActive === menu.id }"
            class="side-menu-list"
            @click="sideMenuActive = menu.id"
          >
            {{ menu.text }}
          </div>
        </div>

        <!-- Menu Content -->
        <div class="menu-content">
          <!-- General -->
          <div v-if="sideMenuActive === 'general'">
            <!-- Advance Report -->
            <div
              v-if="useConfigAdvanceExportAndImport"
              class="card-layer"
            >
              <div class="d-flex align-items-center justify-content-between">
                <h4>Advance Import and Export</h4>
                <j-toggle
                  v-model="dataSetup.advance_report"
                  class="fix-position-toggle"
                />
              </div>

              <p class="description mb-0">
                Enable configuration for advanced import and export views in the Experience Manager module.
              </p>

              <div class="warning-information d-flex align-items-start">
                <img
                  src="@/assets/icon/info-circle.svg"
                  alt="warning-icon"
                >
                <div class="d-flex flex-column">
                  <p class="title-warning">Information</p>
                  <p class="desc-warning">
                    Please contact your Administrator to ensure the infrastructure supports this configuration.
                  </p>
                </div>
              </div>
            </div>

            <!-- Move Table -->
            <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Move Table</h4>
                <j-toggle
                  v-model="dataSetupV2.data_manager_enable_move_table"
                  class="fix-position-toggle"
                />
              </div>

              <p class="description mb-0">
                Enable configuration for allows moving table between table groups
              </p>
            </div>

            <!-- Maintenance Mode -->
            <!-- <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Maintenance Mode</h4>
                <j-toggle
                  class="fix-position-toggle" />
              </div>

              <p class="description mb-0">
                Prevent users from accessing the application during the maintenance process
              </p>
            </div> -->
          </div>

          <!-- Login & Security -->
          <div v-if="sideMenuActive === 'security'">
            <!-- Auto Deactived User -->
            <!-- <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Auto Deactived User</h4>
                <j-toggle
                  v-model="dataSetup.auto_deactivated_user"
                  class="fix-position-toggle"
                />
              </div>

              <p
                :class="dataSetup.auto_deactivated_user ? 'mb-3' : 'mb-0'"
                class="description"
              >
                If there is no login activity within a certain time, the user will be deactivated
              </p>

              <div v-if="dataSetup.auto_deactivated_user">
                <label> Days Period </label>
                <div class="d-flex align-items-start">
                  <j-input
                    v-model="dataSetup.auto_deactivated_user_period_day"
                    :error-required="false"
                    type="number"
                    placeholder="Input value"
                    class="input-value"
                  />
                  <button
                    :disabled="!dataSetup.auto_deactivated_user_period_day"
                    @click="updateDataSettings"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div> -->

            <!-- Periodic Password Change -->
            <!-- <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Periodic Password Change</h4>
                <j-toggle
                  v-model="dataSetup.periodic_password_change"
                  class="fix-position-toggle"
                />
              </div>

              <p
                :class="dataSetup.periodic_password_change ? 'mb-3' : 'mb-0'"
                class="description"
              >
                Rules for changing passwords periodically within a certain period of time
              </p>

              <div v-if="dataSetup.periodic_password_change">
                <label> Days Period </label>
                <div class="d-flex align-items-start">
                  <j-input
                    v-model="dataSetup.periodic_password_change_period_day"
                    :error-required="false"
                    type="number"
                    placeholder="Input value"
                    class="input-value"
                  />
                  <button
                    :disabled="!dataSetup.periodic_password_change_period_day"
                    @click="updateDataSettings"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div> -->

            <!-- Device Limits -->
            <!-- <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Device Limits</h4>
                <j-toggle
                  v-model="dataSetup.device_limit"
                  class="fix-position-toggle"
                />
              </div>

              <p
                :class="dataSetup.device_limit ? 'mb-3' : 'mb-0'"
                class="description"
              >
                Limiting the devices that can be used
              </p>

              <div v-if="dataSetup.device_limit">
                <label> Devices </label>
                <div class="d-flex align-items-start">
                  <j-input
                    v-model="dataSetup.device_limit_total"
                    :error-required="false"
                    type="number"
                    placeholder="Input value"
                    class="input-value"
                  />
                  <button
                    :disabled="!dataSetup.device_limit_total"
                    @click="updateDataSettings"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div> -->

            <!-- Periodic Login Session -->
            <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Periodic Login Session</h4>
              </div>

              <p class="description">
                Time period to define login session expires
              </p>

              <div class="card-component-wrap">
                <b-form>
                  <label> Period </label>
                  <j-single-select
                    v-model="dataSetup.token_expired"
                    :options="getSessionOptions"
                    :error-required="false"
                    placeholder="Select Period" />
                </b-form>

                <button
                  class="ml-0"
                  @click="updateDataSettings"
                >
                  Update
                </button>
              </div>

              <div class="information-session">
                <img src="@/assets/icon/info.svg" >
                <div>
                  <p>Information</p>
                  <span>Changing the Period will affect the authorization to access Officeless Applications.</span>
                </div>
              </div>
            </div>

            <!-- Periodic Refresh Session -->
            <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Periodic Refresh Session</h4>
              </div>

              <p class="description">
                Time period to define login session expires
              </p>

              <div class="card-component-wrap">
                <b-form>
                  <label> Period </label>
                  <j-single-select
                    v-model="dataSetup.refresh_token_expired"
                    :options="refreshSessionOptions"
                    :error-required="false"
                    placeholder="Select Period" />
                </b-form>

                <button
                  class="ml-0"
                  @click="updateDataSettings"
                >
                  Update
                </button>
              </div>

              <div class="information-session">
                <img src="@/assets/icon/info.svg" >
                <div>
                  <p>Information</p>
                  <span>Changing the Period will affect the authorization to access Officeless Applications.</span>
                </div>
              </div>
            </div>

            <!-- Force Change Password -->
            <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Force Change Password</h4>
                <j-toggle
                  v-model="dataSetup.force_change_password"
                  class="fix-position-toggle" />
              </div>

              <p class="description mb-0">
                Force new user to change their password
              </p>
            </div>

            <!-- Password History Validation -->
            <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Password History Validation</h4>
                <j-toggle
                  v-model="dataSetup.history_password_validation"
                  class="fix-position-toggle" />
              </div>

              <p class="description mb-0">
                Enable validation to disallow user from using previous password
              </p>
            </div>

            <!-- Suspected Login Validation -->
            <div class="card-layer">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Suspected Login Validation</h4>
                <j-toggle
                  v-model="dataSetup.suspected_login_validation"
                  class="fix-position-toggle" />
              </div>

              <p class="description">
                Enable validation to handle suspected login
              </p>

              <div
                v-if="dataSetup.suspected_login_validation"
                class="card-component-wrap">
                <b-form :class="{'error-input' : $v.dataSetup.suspected_login_validation_config.max_login_trial.$error}">
                  <label> Maximum Login Trial </label>
                  <j-input
                    v-model="dataSetup.suspected_login_validation_config.max_login_trial"
                    :error-required="false"
                    type="number"
                    placeholder="Input Value"
                  />
                </b-form>

                <b-form :class="{'error-input': $v.suspectedLoginValidationAction.$error}">
                  <label> Validation do </label>
                  <j-single-select
                    v-model="suspectedLoginValidationAction"
                    :options="suspectedLoginOptions"
                    :error-required="false"
                    placeholder="Select Validation" />
                </b-form>

                <b-form
                  v-if="suspectedLoginValidationAction === 'suspend_user'"
                  :class="{'error-input': $v.dataSetup.suspected_login_validation_config.suspend_period.$error}">
                  <label> Suspension Period </label>
                  <j-single-select
                    v-model="dataSetup.suspected_login_validation_config.suspend_period"
                    :options="suspendPeriodOptions"
                    :error-required="false"
                    placeholder="Select Period" />
                </b-form>

                <button
                  class="ml-0"
                  @click="updateDataSettings"
                >
                  Update
                </button>
              </div>
              <div
                v-if="suspectedLoginValidationAction === 'block_user'"
                class="information-session">
                <img src="@/assets/icon/info.svg" >
                <div>
                  <p>Information</p>
                  <span>A blocked user can be activated by changing the Active status in the user's Administrator settings..</span>
                </div>
              </div>
            </div>

            <!-- Concurrent Login Session -->
            <div
              v-if="useConfigConcurrentLogin"
              class="card-layer"
            >
              <h4>Concurrent Login Session Device Restrictions</h4>
              <p class="description">
                Limit or control the number of devices or sessions a user can log in to simultaneously
              </p>

              <div class="card-component-wrap">
                <b-form>
                  <label> Restriction options </label>
                  <j-single-select
                    v-model="dataSetupV2.concurrent_login"
                    :options="concurrentLoginOptions"
                    :error-required="false"
                    placeholder="Select restriction" />
                </b-form>

                <button
                  class="ml-0"
                  @click="updateConcurrentDevice"
                >
                  Update
                </button>
              </div>
            </div>

            <!-- Two-Factor Authentication -->
            <div
              v-if="useGen1TwoFactor"
              class="card-layer"
              data-test-id="two-factor-card"
            >
              <div class="d-flex align-items-center justify-content-between">
                <h4 id="two-factor-title">Two-Factor Authentication (2FA)</h4>
                <j-toggle
                  :value="twoFactorSwitch"
                  :disabled="firstLoad || twoFactorSaving"
                  aria-labelledby="two-factor-title"
                  class="fix-position-toggle"
                  data-test-id="two-factor-toggle"
                  @input="openTwoFactorDialog" />
              </div>

              <p class="description two-factor-description mb-0">
                Require all Studio and application users in this company to enter a one-time code sent to their email after their password, every time they sign in or change their password.
              </p>
              <p
                v-if="twoFactorAuth"
                class="two-factor-active"
                data-test-id="two-factor-active-status">
                Active · Users sign in with password and email code
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="modalConfirmation"
      class="mod-form modal-form-ui"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <j-popup-confirmation
        :message="messageConcurrent"
        @close="closePopupConfirmation"
        @confirm="updateDataSettingsV2"
      />
    </b-modal>

    <b-modal
      ref="modalTwoFactor"
      :no-close-on-esc="twoFactorSaving"
      :hide-header-close="twoFactorSaving"
      class="mod-form modal-form-ui"
      modal-class="two-factor-modal"
      centered
      no-close-on-backdrop
      @hidden="restoreTwoFactorSwitch"
    >
      <div
        class="two-factor-dialog"
        data-test-id="two-factor-dialog"
        role="alertdialog"
        aria-labelledby="two-factor-dialog-title"
        aria-describedby="two-factor-dialog-body">
        <div
          :class="twoFactorSwitch ? 'is-on' : 'is-off'"
          class="two-factor-dialog__icon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            aria-hidden="true">
            <path
              d="M12 2.5 L20 5.5 V11.5 C20 16.5 16.6 20.2 12 21.5 C7.4 20.2 4 16.5 4 11.5 V5.5 Z"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linejoin="round" />
            <path
              v-if="twoFactorSwitch"
              d="M8.5 12 L11 14.5 L15.5 9.5"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              v-else
              d="M12 8 V12.5 M12 15.5 V15.6"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round" />
          </svg>
        </div>
        <h2
          id="two-factor-dialog-title"
          class="two-factor-dialog__title"
          data-test-id="two-factor-dialog-title">{{ twoFactorDialog.title }}</h2>
        <div
          id="two-factor-dialog-body"
          class="two-factor-dialog__body"
          data-test-id="two-factor-dialog-body">
          <template v-if="twoFactorSwitch">
            <p>All Studio and application users in this company, <strong>including you</strong>, will be logged out now on web and mobile.</p>
            <p>From their next sign-in, everyone must enter a one-time code sent to their email after their password.</p>
            <div
              class="two-factor-dialog__note"
              data-test-id="two-factor-dialog-mobile-note"
              role="note">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                aria-hidden="true">
                <path
                  d="M12 3 L22 20 H2 Z"
                  fill="none"
                  stroke="#B26A00"
                  stroke-width="2"
                  stroke-linejoin="round" />
                <path
                  d="M12 10 V14 M12 17 V17.1"
                  stroke="#B26A00"
                  stroke-width="2"
                  stroke-linecap="round" />
              </svg>
              <p><strong>Mobile app users must update Officeless to version 2.6.3 or later.</strong> Older versions can't sign in once 2FA is on.</p>
            </div>
          </template>
          <p v-else>Users will go back to signing in with their password only. No one will be logged out.</p>
        </div>
        <div class="two-factor-dialog__actions">
          <button
            :disabled="twoFactorSaving"
            class="two-factor-dialog__cancel"
            data-test-id="two-factor-dialog-cancel"
            @click="cancelTwoFactor"
          >
            Cancel
          </button>
          <button
            :disabled="twoFactorSaving"
            class="two-factor-dialog__confirm"
            data-test-id="two-factor-dialog-confirm"
            @click="confirmTwoFactor"
          >
            {{ twoFactorDialog.confirm }}
          </button>
        </div>
      </div>
    </b-modal>

    <div
      v-if="twoFactorError"
      class="two-factor-alert"
      data-test-id="two-factor-error-alert"
      role="alert">
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        aria-hidden="true">
        <circle
          cx="12"
          cy="12"
          r="9"
          fill="none"
          stroke="#C62828"
          stroke-width="2" />
        <path
          d="M12 7 V13 M12 16.5 V16.6"
          stroke="#C62828"
          stroke-width="2"
          stroke-linecap="round" />
      </svg>
      <p><strong>{{ twoFactorError.title }}</strong> {{ twoFactorError.body }}</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, func-names */
import jPopupConfirmation from '@/components/popup/jPopupConfirmation';
import { mapState, mapActions } from 'vuex';
import { requiredIf } from 'vuelidate/lib/validators';
import jMixFlagsmith from '@/mixins/jMixFlagsmith';
import jMixTwoFactor from '@/mixins/jMixTwoFactor';

export default {
  components: {
    jPopupConfirmation,
  },

  mixins: [jMixFlagsmith, jMixTwoFactor],

  data() {
    return {
      firstLoad: true,
      dataSetup: {
        auto_deactivated_user: false,
        auto_deactivated_user_period_day: '',
        device_limit: false,
        device_limit_total: '',
        periodic_password_change: false,
        periodic_password_change_period_day: '',
        advance_report: false,
        // maintenance_mode: false,
        force_change_password: false,
        history_password_validation: false,
        suspected_login_validation: false,
        suspected_login_validation_config: {
          max_login_trial: '',
          is_blocked_user: false,
          is_suspend_user: false,
          suspend_period: null,
        },
        token_expired: 8766,
        refresh_token_expired: 8766,
      },
      firstLoadV2: true,
      dataSetupV2: {
        data_manager_enable_move_table: false,
        concurrent_login: 'allow_multiple_device_login',
      },
      sideMenuActive: 'general',
      sideMenu: [
        {
          id: 'general',
          text: 'General',
        },
        {
          id: 'security',
          text: 'Login & Security',
        },
      ],
      suspectedLoginValidationAction: null,
      suspectedLoginOptions: [
        { id: 'block_user', text: 'Block User' },
        { id: 'suspend_user', text: 'Suspend User' },
      ],
      suspendPeriodOptions: [
        { id: '5 minutes', text: '5 minutes' },
        { id: '15 minutes', text: '15 minutes' },
        { id: '30 minutes', text: '30 minutes' },
        { id: '1 hour', text: '1 hour' },
        { id: '2 hours', text: '2 hours' },
        { id: '6 hours', text: '6 hours' },
        { id: '12 hours', text: '12 hours' },
        { id: '24 hours', text: '24 hours' },
        { id: '3 days', text: '3 days' },
        { id: '6 days', text: '6 days' },
        { id: '12 days', text: '12 days' },
      ],
      loginSessionOptions: [
        { id: 1, text: '1 Hour' },
        { id: 24, text: '1 Day' },
        { id: 168, text: '7 Days' },
        { id: 731, text: '1 Month' },
        { id: 4380, text: '6 Months' },
        { id: 8766, text: '1 Year' },
      ],
      loginSessionPeriodicOptions: [
        { id: 0.25, text: '15 Minutes' },
        { id: 0.5, text: '30 Minutes' },
        { id: 0.75, text: '45 Minutes' },
        { id: 1, text: '1 Hour' },
        { id: 24, text: '1 Day' },
        { id: 168, text: '7 Days' },
        { id: 731, text: '1 Month' },
        { id: 4380, text: '6 Months' },
        { id: 8766, text: '1 Year' },
      ],
      refreshSessionOptions: [
        { id: 168, text: '7 Days' },
        { id: 731, text: '1 Month' },
        { id: 4380, text: '6 Months' },
        { id: 8766, text: '1 Year' },
      ],
      concurrentLoginOptions: [
        { id: 'allow_multiple_device_login', text: 'Allow multiple devices login' },
        { id: 'allow_single_login_per_device', text: 'Allow single device login' },
        { id: 'allow_single_login_per_device_type', text: 'Allow single login per device type' },
      ],
      messageConcurrent: `Are you sure want to update the session device restriction settings? <br/>
      Changing this configuration will automatically log out all active sessions, including the one currently used to make this change.`,
      useConfigConcurrentLogin: !!Number(process.env.RLS_CONCURRENT_LOGIN),
      useConfigAdvanceExportAndImport: !!(process.env.ADVANCE_EXPORT_AND_IMPORT === 'true'),
      useEnhanchedPeriodicSession: !!Number(process.env.RLS_ENHANCEMENT_PERIODIC_SESSION),
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreLogin', ['profile_data']),

    role() {
      return Number(localStorage.getItem('userRole') || this.profile_data.userRole);
    },

    tabMenu() {
      return [
        { url: '/administrator', label: 'USER', show: true, active: false },
        { url: '/administrator/position', label: 'POSITION', show: true, active: false },
        { url: '/administrator/unit', label: 'UNIT', show: true, active: false },
        { url: '/administrator/location', label: 'LOCATION', show: true, active: false },
        { url: '/administrator/layer', label: 'LAYER', show: true, active: false },
        { url: '/administrator/company/profile', label: 'COMPANY', show: true, active: false },
        { url: '/administrator/company/settings', label: 'SETTINGS', show: this.role === 1, active: true },
      ];
    },

    getSessionOptions() {
      if (this.useEnhanchedPeriodicSession) {
        return this.loginSessionPeriodicOptions;
      }
      return this.loginSessionOptions;
    },
  },

  watch: {
    'dataSetup.advance_report': function () {
      this.updateDataSettings();
    },

    'dataSetupV2.data_manager_enable_move_table': function () {
      this.updateDataSettingsV2();
    },

    'dataSetup.auto_deactivated_user': function (val) {
      if (!val) this.dataSetup.auto_deactivated_user_period_day = 0;
      this.updateDataSettings();
    },

    'dataSetup.periodic_password_change': function (val) {
      if (!val) this.dataSetup.periodic_password_change_period_day = 0;
      this.updateDataSettings();
    },

    'dataSetup.device_limit': function (val) {
      if (!val) this.dataSetup.device_limit_total = '';
      this.updateDataSettings();
    },

    // 'dataSetup.maintenance_mode': function () {
    //   this.updateDataSettings();
    // },

    'dataSetup.force_change_password': function () {
      this.updateDataSettings();
    },

    'dataSetup.history_password_validation': function () {
      this.updateDataSettings();
    },

    'dataSetup.suspected_login_validation': function (val) {
      if (!val) {
        this.suspectedLoginValidationAction = null;
        this.updateDataSettings();
      }
    },

    suspectedLoginValidationAction(val) {
      if (val) {
        this.dataSetup.suspected_login_validation_config.is_suspend_user = val !== 'block_user';
        this.dataSetup.suspected_login_validation_config.is_blocked_user = val !== 'suspend_user';
      } else {
        this.dataSetup.suspected_login_validation_config.is_suspend_user = false;
        this.dataSetup.suspected_login_validation_config.is_blocked_user = false;
      }
    },
  },

  created() {
    if (this.$route.params.tab) this.sideMenuActive = this.$route.params.tab;
    this.getDataSettings();
    this.getDataSettingsV2();
  },

  methods: {
    ...mapActions('jStoreSetting', ['actionGetUserCompanySetting', 'actionUpdateUserCompanySetting',
      'actionGetUserCompanySettingV2', 'actionUpdateUserCompanySettingV2']),

    async getDataSettings() {
      const { data, error } = await this.actionGetUserCompanySetting(true);
      if (!error) {
        this.setDataSettings(data);
        this.setTwoFactorFromSetting(data);
        setTimeout(() => {
          this.firstLoad = false;
        }, 300);
      }
    },

    async getDataSettingsV2() {
      const { data, error } = await this.actionGetUserCompanySettingV2(true);
      if (!error) {
        this.setDataSettingsV2(data);
        setTimeout(() => {
          this.firstLoadV2 = false;
        }, 300);
      }
    },

    async updateDataSettings() {
      this.$v.dataSetup.$touch();
      this.$v.suspectedLoginValidationAction.$touch();
      if (!this.firstLoad && !this.$v.dataSetup.$error && !this.$v.suspectedLoginValidationAction.$error) {
        this.normalizeDataSetup();

        const { data, error } = await this.actionUpdateUserCompanySetting(this.dataSetup);
        if (!error) this.setDataSettings(data);
      }
    },

    normalizeDataSetup() {
      this.dataSetup.auto_deactivated_user_period_day = Number(this.dataSetup.auto_deactivated_user_period_day);
      this.dataSetup.device_limit_total = Number(this.dataSetup.device_limit_total);
      this.dataSetup.periodic_password_change_period_day = Number(this.dataSetup.periodic_password_change_period_day);
      this.dataSetup.suspected_login_validation_config.max_login_trial = Number(this.dataSetup.suspected_login_validation_config.max_login_trial);
      this.dataSetup.suspected_login_validation_config.suspend_period = this.dataSetup.suspected_login_validation_config.is_suspend_user ? this.dataSetup.suspected_login_validation_config.suspend_period : '';
      this.dataSetup.token_expired = Number(this.dataSetup.token_expired);
      this.dataSetup.refresh_token_expired = Number(this.dataSetup.refresh_token_expired);
    },

    async updateDataSettingsV2() {
      this.closePopupConfirmation();
      if (!this.firstLoadV2) {
        const bodyUpdate = this._.cloneDeep(this.dataSetupV2);
        if (!this.useConfigConcurrentLogin) delete bodyUpdate.concurrent_login;
        const { data, error } = await this.actionUpdateUserCompanySettingV2(bodyUpdate);
        if (!error) this.setDataSettingsV2(data.data);
      }
    },

    updateConcurrentDevice() {
      this.$refs.modalConfirmation.show();
    },

    closePopupConfirmation() {
      this.$refs.modalConfirmation.hide();
    },

    setDataSettings(data) {
      this.dataSetup.auto_deactivated_user = data.auto_deactivated_user;
      this.dataSetup.auto_deactivated_user_period_day = data.auto_deactivated_user_period_day;
      this.dataSetup.device_limit = data.device_limit;
      this.dataSetup.device_limit_total = data.device_limit_total;
      this.dataSetup.periodic_password_change = data.periodic_password_change;
      this.dataSetup.periodic_password_change_period_day = data.periodic_password_change_period_day;
      this.dataSetup.advance_report = data.advance_report;
      // this.dataSetup.maintenance_mode = data.maintenance_mode;
      this.dataSetup.force_change_password = data.force_change_password;
      this.dataSetup.history_password_validation = data.history_password_validation;
      this.dataSetup.suspected_login_validation = data.suspected_login_validation;
      this.dataSetup.suspected_login_validation_config.max_login_trial = data.suspected_login_validation_config.max_login_trial;
      this.dataSetup.suspected_login_validation_config.suspend_period = data.suspected_login_validation_config.suspend_period || null;
      this.dataSetup.token_expired = data.token_expired || 8766;
      this.dataSetup.refresh_token_expired = data.refresh_token_expired || 8766;

      if (!data.suspected_login_validation_config.is_blocked_user && !data.suspected_login_validation_config.is_suspend_user) {
        this.suspectedLoginValidationAction = null;
      }
      if (data.suspected_login_validation_config.is_blocked_user && !data.suspected_login_validation_config.is_suspend_user) {
        this.suspectedLoginValidationAction = 'block_user';
      }
      if (!data.suspected_login_validation_config.is_blocked_user && data.suspected_login_validation_config.is_suspend_user) {
        this.suspectedLoginValidationAction = 'suspend_user';
      }
    },

    setDataSettingsV2(data) {
      this.dataSetupV2.data_manager_enable_move_table = data.data_manager_enable_move_table;
      this.dataSetupV2.concurrent_login = data.concurrent_login || 'allow_multiple_device_login';
    },
  },

  validations() {
    return {
      dataSetup: {
        suspected_login_validation_config: {
          max_login_trial: {
            required: requiredIf(() => this.dataSetup.suspected_login_validation && this.dataSetup.suspected_login_validation_config.max_login_trial === ''),
          },
          suspend_period: {
            required: requiredIf(() => this.dataSetup.suspected_login_validation && this.dataSetup.suspected_login_validation_config.is_suspend_user),
          },
        },
      },
      suspectedLoginValidationAction: {
        required: requiredIf(() => this.dataSetup.suspected_login_validation),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .wrap-company-setting {
    height: 100%;
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-template-rows: repeat(2, 100%);
    grid-gap: 14px;

    .side-menu {
      background-color: white;
      border: 1px solid #E7E7E7;

      &-list {
        width: 100%;
        height: 34px;
        padding: 8px 10px;
        display: flex;
        align-items: center;
        border-left: 2px solid transparent;
        font-family: 'Poppins-Regular';
        font-size: 14px;
        color: #606060;
        cursor: pointer;

        &.active {
          border-color: #1A85E4;
          box-shadow: 0px 1px 4px rgba(172, 172, 172, 0.25);
        }
      }
    }

    .menu-content {
      background-color: white;
      border: 1px solid #E7E7E7;
      border-radius: 14px;
      padding: 20px;
      overflow-y: auto;

      .card-layer {
        width: 100%;
        background-color: white;
        border: 1px solid #E7E7E7;
        border-radius: 14px;
        padding: 16px;
        margin-bottom: 20px;

        h4 {
          font-family: 'Poppins-Semibold';
          font-size: 16px;
          letter-spacing: 0.02em;
          color:#606060;
          margin-bottom: 0;
        }
        .fix-position-toggle {
          height: 20px;
          margin-right: 40px;
        }
        .description, label {
          font-family: 'Poppins-Regular';
          font-size: 12px;
          color: #606060;
        }
        .description {
          margin-top: 6px;
        }
        label {
          margin-bottom: 6px;
        }
        .input-value {
          width: 50%;
        }
        button {
          padding: 8px 24px;
          font-family: 'Poppins-Semibold';
          font-size: 14px;
          color: white;
          text-align: center;
          background-color: #1A85E4;
          border-radius: 6px;
          border: none;
          margin-left: 16px;

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }
        .card-component-wrap {
          display: grid;
          grid-template-columns: repeat(3, fit-content(263px)) 92px;
          grid-gap: 26px;
          align-items: end;
          justify-items: self-start;
        }
      }

      .warning-information {
        padding: 8px;
        border-radius: 8px;
        background-color: #F5FAFF;
        margin-top: 12px;

        img {
          width: auto;
          height: 18px;
          margin-right: 5px;
        }
        .title-warning {
          font-family: 'Poppins-Semibold';
          font-size: 14px;
          color: #606060;
          margin-bottom: 2px;
        }
        .desc-warning {
          font-family: 'Poppins-Regular';
          font-size: 12px;
          color: #606060;
          margin-bottom: 0px;
        }
      }
    }
  }

  .information-session {
    width: 100%;
    background-color: #F5FAFF;
    margin: 10px 0;
    display: flex;
    align-items: flex-start;
    padding: 6px 5px 6px 5px;
    border-radius: 7px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
    p {
      font-family: 'Poppins-Medium';
      font-size: 12px;
      color: #696014;
      margin-bottom: 0px;
    }
    span {
      font-family: 'Poppins-Regular';
      font-size: 10px;
      color: #696014;
      margin-top: 0px;
      display: block;
    }
  }

  // Two-factor section, dialog and failure alert, as in the CR-5771 design.
  .two-factor-active {
    margin: 6px 0 0;
    font-size: 12px;
    font-weight: 500;
    color: #1E7B4D;
  }

  // Wraps the long sentence to two lines, as in the design.
  .two-factor-description {
    max-width: 640px;
  }

  .two-factor-dialog {
    display: flex;
    flex-direction: column;
    gap: 14px;

    &__icon {
      align-self: center;
      width: 64px;
      height: 64px;
      border-radius: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.is-on { color: #3D7FE0; background: #E6F0FD; }
      &.is-off { color: #C25E12; background: #FDF0E6; }
    }

    &__title {
      margin: 0;
      text-align: center;
      font-family: 'Poppins-SemiBold';
      font-size: 17px;
      line-height: 1.4;
      color: #333333;
    }

    // Weights here come from the font family (base/_typography.scss), not font-weight.
    strong {
      font-family: 'Poppins-Bold';
      font-weight: normal;
    }

    &__body {
      display: flex;
      flex-direction: column;
      gap: 14px;

      > p {
        margin: 0;
        font-size: 13px;
        line-height: 1.6;
        color: #444A52;
        text-align: center;
      }
    }

    &__note {
      display: flex;
      gap: 10px;
      align-items: flex-start;
      background: #FFF6E5;
      border: 1px solid #F2D199;
      border-radius: 8px;
      padding: 10px 12px;

      svg { flex: none; margin-top: 1px; }

      p {
        margin: 0;
        font-size: 12px;
        line-height: 1.5;
        color: #5C3D00;
      }
    }

    &__actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      margin-top: 10px;

      button {
        height: 36px;
        padding: 0 20px;
        border: none;
        border-radius: 6px;
        color: #FFFFFF;
        font-size: 13px;
        font-weight: 500;

        &:disabled { opacity: 0.6; cursor: not-allowed; }
      }
    }

    &__cancel { background: #757575; }
    &__confirm { background: #3D7FE0; }
  }

  .two-factor-alert {
    position: fixed;
    top: 80px;
    right: 24px;
    z-index: 1050;
    max-width: 400px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    background: #FDECEC;
    border: 1px solid #F3C1C1;
    border-radius: 8px;
    padding: 12px 14px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);

    svg { flex: none; margin-top: 2px; }

    p {
      margin: 0;
      font-size: 13px;
      line-height: 1.5;
      color: #8E1B1B;
    }

    strong {
      font-family: 'Poppins-Bold';
      font-weight: normal;
    }
  }
</style>
<style lang="scss">
  // b-modal renders the dialog shell outside this component's scoped styles.
  .mod-form .two-factor-modal {
    .modal-dialog {
      max-width: 480px;
    }

    .modal-content {
      border: none;
      border-radius: 16px;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
    }

    .modal-body {
      padding: 28px 28px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/company/jCompanySetting.vue